/**
* @module vue-mdc-adaptercard 0.8.3
* @exports default
* @copyright (c) 2017-present, Sebastien Tasson
* @license https://opensource.org/licenses/MIT
* @implements {"material-components-web":"^0.28.0"}
* @requires {"vue":"^2.5.6"}
* @see https://github.com/stasson/vue-mdc-adapter
*/

import { mdcButtonBase } from '../button';

function BasePlugin(components) {
  return {
    version: '0.8.3',
    install: function install(vm) {
      for (var key in components) {
        var component = components[key];
        vm.component(component.name, component);
      }
    },
    components: components
  };
}

/* global CustomEvent */

var mdcCard = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "mdc-card", class: _vm.classes }, [_vm._t("default")], 2);
  }, staticRenderFns: [],
  name: 'mdc-card',
  props: {
    'dark': Boolean
  },
  data: function data() {
    return {
      classes: {
        'mdc-card--theme-dark': this.dark
      }
    };
  }
};

var mdcCardMedia = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('section', { staticClass: "mdc-card-media mdc-card__media", style: _vm.styles, attrs: { "classes": { 'mdc-theme--dark': _vm.dark } } }, [_vm._t("default")], 2);
  }, staticRenderFns: [],
  name: 'mdc-card-media',
  props: {
    src: String,
    size: String,
    position: String,
    height: [String, Number],
    dark: Boolean
  },
  computed: {
    styles: function styles() {
      var styles = {
        backgroundImage: "url(" + this.src + ")",
        backgroundSize: this.size,
        backgroundPosition: this.position
      };

      if (this.height) {
        styles.height = this.height + "px";
      }

      return styles;
    }
  }
};

var mdcCardHeader = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('section', { staticClass: "mdc-card-header mdc-card__primary" }, [_vm._t("default", [_vm.title ? _c('h1', { staticClass: "mdc-card__title", class: { 'mdc-card__title--large': _vm.largeTitle } }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _vm._v(" "), _vm.subtitle ? _c('h2', { staticClass: "mdc-card__subtitle" }, [_vm._v(" " + _vm._s(_vm.subtitle) + " ")]) : _vm._e()])], 2);
  }, staticRenderFns: [],
  name: 'mdc-card-header',
  props: {
    'title': String,
    'subtitle': String,
    'large-title': { type: Boolean, default: true }
  }
};

var mdcCardTitle = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('h1', { staticClass: "mdc-card-title mdc-card__title", class: { 'mdc-card__title--large': _vm.large } }, [_vm._t("default")], 2);
  }, staticRenderFns: [],
  name: 'mdc-card-title',
  props: {
    'large': Boolean
  }
};

var mdcCardSubtitle = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('h2', { staticClass: "mdc-card-subtitle mdc-card__subtitle" }, [_vm._t("default")], 2);
  }, staticRenderFns: [],
  name: 'mdc-card-subtitle'
};

var mdcCardText = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('section', { staticClass: "mdc-card-text mdc-card__supporting-text" }, [_vm._t("default")], 2);
  }, staticRenderFns: [],
  name: 'mdc-card-text'
};

var mdcCardHorizontal = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "mdc-card-horizontal mdc-card__horizontal-block" }, [_vm._t("default")], 2);
  }, staticRenderFns: [],
  name: 'mdc-card-horizontal'
};

var mdcCardImg = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('img', { staticClass: "mdc-card-img mdc-card__media-item", class: _vm.classes, attrs: { "src": _vm.src } });
  }, staticRenderFns: [],
  name: 'mdc-card-img',
  props: {
    src: {
      type: String,
      required: true
    },
    mult: {
      type: [Number, String],
      validator: function validator(value) {
        return [1, 1.5, 2, 3].indexOf(Number(value)) !== -1;
      }
    }
  },
  computed: {
    classes: function classes() {
      var mult = Number(this.mult);
      return {
        'mdc-card__media-item--1dot5x': mult === 1.5,
        'mdc-card__media-item--2x': mult === 2,
        'mdc-card__media-item--3x': mult === 3
      };
    }
  }
};

var mdcCardActionButton = {
  name: 'mdc-card-action-button',
  extends: mdcButtonBase,
  props: {
    accent: Boolean
  },
  data: function data() {
    return {
      classes: {
        'mdc-button': true,
        'mdc-card__action': true,
        'mdc-card-action-button': true,
        'mdc-button--compact': true,
        'mdc-button--accent': this.accent
      }
    };
  }
};

var mdcCardActions = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('section', { staticClass: "mdc-card-actions", class: _vm.classes }, [_vm._t("default")], 2);
  }, staticRenderFns: [],
  name: 'mdc-card-actions',
  props: {
    vertical: Boolean
  },
  components: {
    'mdc-card-action-button': mdcCardActionButton
  },
  data: function data() {
    return {
      classes: {
        'mdc-card__actions': true,
        'mdc-card__actions--vertical': this.vertical
      }
    };
  }
};

var index = BasePlugin({
  mdcCard: mdcCard,
  mdcCardMedia: mdcCardMedia,
  mdcCardHeader: mdcCardHeader,
  mdcCardTitle: mdcCardTitle,
  mdcCardSubtitle: mdcCardSubtitle,
  mdcCardText: mdcCardText,
  mdcCardHorizontal: mdcCardHorizontal,
  mdcCardImg: mdcCardImg,
  mdcCardActions: mdcCardActions,
  mdcCardActionButton: mdcCardActionButton
});

export { mdcCard, mdcCardMedia, mdcCardHeader, mdcCardTitle, mdcCardSubtitle, mdcCardText, mdcCardHorizontal, mdcCardImg, mdcCardActions, mdcCardActionButton };
export default index;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-mdc-adapter/dist/card/index.js
// module id = null
// module chunks = 